interface MacroData {
  protein_g: number;
  carbs_g: number;
  fat_g: number;
}

export default function NutritionMacroBar({ macros }: { macros: MacroData }) {
  const total = macros.protein_g + macros.carbs_g + macros.fat_g || 1;
  const proteinPct = (macros.protein_g / total) * 100;
  const carbsPct = (macros.carbs_g / total) * 100;
  const fatPct = (macros.fat_g / total) * 100;

  return (
    <div className="xpn-macro-bar">
      <div style={{ display: "flex", gap: 2, height: 12, borderRadius: 6, overflow: "hidden" }}>
        <div style={{ flex: proteinPct, background: "var(--xpn-color-success)", minWidth: proteinPct > 0 ? 4 : 0 }} />
        <div style={{ flex: carbsPct, background: "var(--xpn-color-warning)", minWidth: carbsPct > 0 ? 4 : 0 }} />
        <div style={{ flex: fatPct, background: "var(--xpn-color-danger)", minWidth: fatPct > 0 ? 4 : 0 }} />
      </div>
      <div style={{ display: "flex", gap: 16, marginTop: 6, fontSize: 12 }}>
        <span>
          <span style={{ color: "var(--xpn-color-success)", fontWeight: 600 }}>●</span> Protein{" "}
          <span className="xpn-text-muted">{macros.protein_g.toFixed(1)}g</span>
        </span>
        <span>
          <span style={{ color: "var(--xpn-color-warning)", fontWeight: 600 }}>●</span> Carbs{" "}
          <span className="xpn-text-muted">{macros.carbs_g.toFixed(1)}g</span>
        </span>
        <span>
          <span style={{ color: "var(--xpn-color-danger)", fontWeight: 600 }}>●</span> Fat{" "}
          <span className="xpn-text-muted">{macros.fat_g.toFixed(1)}g</span>
        </span>
      </div>
    </div>
  );
}
